import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import {MSUser} from '../../models/user.model';
import {CypherLocalStore, FidjiTokenManagerService} from '@immanens-com/fidji-api-module';

/*
* User controller
*/
@Injectable()
export class UserControllerService {

  readonly USER_STORAGE_KEY = 'x-storage-user';

  private userSubject = new BehaviorSubject<MSUser>(null);
  public readonly userChange = this.userSubject.asObservable();
  public get user(): MSUser {
      return this.userSubject.getValue();
  }
  public set user(user: MSUser) {
    this.userSubject.next(user);
    this.isLoggedSubject.next(user != null);
    if (user == null) {
      CypherLocalStore.clearLocalKey(this.USER_STORAGE_KEY);
    } else {
      CypherLocalStore.setLocalKey(this.USER_STORAGE_KEY, user);
    }
  }

  private isLoggedSubject = new BehaviorSubject<boolean>(false);
  public readonly isLoggedChange: Observable<boolean> = this.isLoggedSubject.asObservable();
  public get isLogged(): boolean {
    return this.isLoggedSubject.getValue();
  }

  constructor(private tokenManager: FidjiTokenManagerService) {
    this.user = CypherLocalStore.getLocalKey(this.USER_STORAGE_KEY) as MSUser;
  }

  public logoutUser() {
    this.tokenManager.logoutUser();
    this.user = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/user/user-controller.service.ts